export default "__VITE_ASSET__Dt9behef__"